import { useMemo } from 'react'

import { SEO_FIELDS_SLUG } from 'common/SeoFields/constants'
import { WYSIWYG_SLUG } from 'common/WYSIWYG/constants'
import { GEO_SLUG, PROGRAM_CARD_SLUG } from '../constants'

export function useProgramData(state: any, isPut: boolean = false) {
  return useMemo(() => {
    const data = {
      'type': 'program',
      'seo_fields': state[SEO_FIELDS_SLUG],
      ...state[PROGRAM_CARD_SLUG],
      ...state[GEO_SLUG],
      'body': state[WYSIWYG_SLUG][WYSIWYG_SLUG],
    }
    
    // @ts-ignore
    if (isPut) data['_method'] = 'PUT'

    return data
  }, [state])
}